<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
        ref="xTable"
        class="table-style"
        stripe
        import-config
        export-config
        highlight-hover-row
        show-overflow
        show-footer
        max-height="650"
        border="none"
        align="center"
        :loading="loading"
        :footer-cell-class-name="footerCellClassName"
        :footer-method="footerMethod"
        :data="tableData"
        resizable
        :filter-config="{remote: true}"
        @filter-change="filterChangeMethod"
    >
      <vxe-table-column
          type="seq"
          title="序号"
          align="center"
          width="60"
      ></vxe-table-column>
      <vxe-table-column field="detailNum" title="详情编号" min-width="130">
        <template slot-scope="{ row }">
          <span
              @click="viewDetail(row)"
              style="color: #2d8cf0; cursor: pointer"
          >{{ row.detailNum }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column field="flowNum" title="流程编号" min-width="130">
        <template slot-scope="{ row }">
          <span v-if="row.source == 1">{{ row.flowNum }}</span>
          <span
              v-else
              @click="openProcedureDetail(row.flowId, 2)"
              style="color: #2d8cf0; cursor: pointer"
          >{{ row.flowNum }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column field="flowType" title="流程类型" min-width="100"
                        :filters="[{ label: '费用支出流程', value: 3 },{ label: '款项收入流程',value: 2 },{ label: '开票申请流程',value: 4 },{ label: '抵扣票申请流程',value: 5 }]"
                        :filter-multiple="true">
        <template slot-scope="{ row }">
          <span>{{ row.flowType }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="clientName"
          title="客户名称"
          min-width="120"
      ></vxe-table-column>
      <vxe-table-column field="addDate" title="日期" min-width="140">
        <template v-slot="{ row }">
          <span>{{ row.addDate | timeFormatDate }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="note"
          title="摘要"
          min-width="140"
      ></vxe-table-column>
      <vxe-table-column
          field="invoiceAmount"
          title="发票金额"
          min-width="150"
      ></vxe-table-column>
      <vxe-table-column
          field="debitAmount"
          title="借方"
          min-width="150"
      ></vxe-table-column>
      <vxe-table-column
          field="creditAmount"
          title="贷方"
          min-width="150"
      ></vxe-table-column>
      <vxe-table-column
          field="balance"
          title="余额"
          min-width="120"
      ></vxe-table-column>
      <vxe-table-column
          field="compName"
          title="所属公司"
          min-width="120"
      ></vxe-table-column>

      <vxe-table-column
          field="salesMan"
          title="业务员"
          min-width="100"
      ></vxe-table-column>
    </vxe-table>
    <vxe-modal
        v-model="isShowCollectionDetail"
        width="1300"
        height="680"
        resize
        remember
    >
      <div slot="title">收付款详情</div>
      <collection-detail
          :cate="cate"
          :isShow="isShowCollectionDetail"
          ref="collectionDetail"
          @close="isShowCollectionDetail = false"
      ></collection-detail>
    </vxe-modal>
    <vxe-modal
        v-model="isShowPaymentDetail"
        width="1300"
        height="680"
        resize
        remember
    >
      <div slot="title">收付款详情</div>
      <payment-detail
          :cate="cate"
          :isShow="isShowPaymentDetail"
          ref="paymentDetail"
          @close="isShowPaymentDetail = false"
      ></payment-detail>
    </vxe-modal>
    <vxe-modal
        v-model="isShowInvoiceDetail"
        title="发票详情"
        width="1200"
        height="920"
        resize
        remember
    >
      <detail
          ref="invoiceDetail"
          :cate="cate"
          @close="isShowInvoiceDetail = false"
          @init="getData"
      ></detail>
    </vxe-modal>
    <vxe-modal
        v-model="isShowCarryOverDetail"
        title="结转详情"
        width="1300"
        height="460"
        resize
        remember
    >
      <carry-over-detail
          :isShow="isShowCarryOverDetail"
          ref="carryOverDetail"
          @close="isShowCarryOverDetail = false"
      ></carry-over-detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {timeFormatDate} from "@/filters/time";
import {bankLogFooter, showLoading, hideLoading, amountBankLogFooter} from "@/utils/util";
import openProcedureDetailTwo from "@/mixin/viewOrderDetail";
import getAuthOrization from "@/mixin/getAuthOrization";
import CollectionDetail from "@/views/payment2.0/CollectionDetail.vue";
import PaymentDetail from "@/views/payment2.0/PaymentDetail.vue";
import CarryOverDetail from "@/views/payment2.0/CarryOverDetail.vue";
import Detail from "@/components/order2.0/Invoice/Detail";

const empties = [undefined, "", null, "null", {}, []];

export default {
  components: {CollectionDetail, PaymentDetail, Detail, CarryOverDetail},
  props: ["id", "pageTab"],
  mixins: [getAuthOrization, openProcedureDetailTwo],
  data() {
    return {
      loading: false,
      tableData: [],
      queryAction: '',
      cate: "Collection",
      isShowCollectionDetail: false,
      isShowPaymentDetail: false,
      isShowInvoiceDetail: false,
      isShowCarryOverDetail: false,
    };
  },
  watch: {
    pageTab() {
      this.pageTab === 8 ? this.getData() : "";
    }
  },
  methods: {
    filterChangeMethod({values}) {
      let sourceTypes = null;
      if (values.length > 0) {
        sourceTypes = values;
      } else {
        sourceTypes = null;
      }
      this.getData(sourceTypes);
    },
    init() {
      this.getData();
    },
    async getData(sourceTypes) {
      this.tableData = [];
      this.queryAction = "saleManAmount";
      this.loading = true;

      let params = {
        ordersId: this.id,
        sourceTypes: sourceTypes ? sourceTypes : null
      };
      // params.orderBy = 2;
      let res = await $api.twoReport.request(this.queryAction, params);
      if (res.status === 1) {
        let curTableData = res.data.salemanAmount;
        // let firstRow = {
        //   debitAmount: "期初余额：",
        //   balance: res.data.initBalance
        // };
        // curTableData.unshift(firstRow);
        for (let i = 0; i < curTableData.length; i++) {
          let obj = curTableData[i];
          if (i === 0) {
            obj.balance = (Number(curTableData[i].debitAmount) -
                Number(curTableData[i].creditAmount)).toFixed(2);
          } else {
            obj.balance = (
                Number(curTableData[i - 1].balance) +
                Number(curTableData[i].debitAmount) -
                Number(curTableData[i].creditAmount)
            ).toFixed(2);
          }
        }
        this.tableData = curTableData;

        this.loading = false;
      } else {
        if (empties.includes(res.message)) res.message = "接口异常";
        this.$XModal.message(res.message);
      }
    },
    footerCellClassName({$rowIndex, column, columnIndex}) {
      return "footer-cell";
    },
    footerMethod({columns, data}) {
      return amountBankLogFooter({columns, data});
    },
    viewDetail(row) {
      switch (row.flowTypeCode) {
        case 1:
          this.cate = "Collection";
          this.isShowCollectionDetail = true;
          this.$refs.collectionDetail.setEdit(false);
          this.$refs.collectionDetail.init(row.detailId);
          break;
        case 2:
          this.cate = "Payment";
          this.isShowPaymentDetail = true;
          this.$refs.paymentDetail.setEdit(false);
          this.$refs.paymentDetail.init(row.detailId);
          break;
        case 3:
          this.cate = "SellerPayment";
          this.isShowPaymentDetail = true;
          this.$refs.paymentDetail.setEdit(false);
          this.$refs.paymentDetail.init(row.detailId);
          break;
        case 4:
          this.cate = "Sales";
          this.isShowInvoiceDetail = true;
          this.$refs.invoiceDetail.setEdit(false);
          this.$refs.invoiceDetail.initDetail(row.invoiceId);
          break;
        case 5:
          this.cate = "Income";
          this.isShowInvoiceDetail = true;
          this.$refs.invoiceDetail.setEdit(false);
          this.$refs.invoiceDetail.initDetail(row.invoiceId);
          break;
        case 6: // 结转流程详情
          this.isShowCarryOverDetail = true;
          this.$refs.carryOverDetail.initDetail(row.detailId);
          break;
      }
    }
  }
};
</script>

<style></style>
  